<template>
  <transition name="modal">
    <div class="modal-mask" @click.self="cancel">
      <div class='coursework-viewer__comment-panel_header_mobile'>
        <div class='coursework-viewer__comment-panel_header_row'>
          <div class='coursework-viewer__comment-panel_header_user'>
            <div class='coursework-viewer__comment-panel_header_user_avatar'>
              <img :src="current_user.avatar">
            </div>
            <div class='coursework-viewer__comment-panel_header_user_name'>{{current_user.full_name}}</div>
          </div>
        </div>
        <comment-editor :value="value" @persist="persist" @cancel="cancel" :class="{'is-open': true}"/>
      </div>
    </div>
  </transition>
</template>

<script>
  import commentEditor from './comment-editor.vue'
  export default {
    props: {
      current_user: Object,
      value: String
    },
    components: {
      commentEditor
    },
    computed: {

    },
    methods: {
      cancel() {
        this.$emit('cancel');
      },
      persist(content) {
        this.$emit('persist', content);
      }
    }
  }
</script>
